import script from "./UncategorisedTransactionsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UncategorisedTransactionsPage.vue?vue&type=script&setup=true&lang=ts"

import "./UncategorisedTransactionsPage.vue?vue&type=style&index=0&id=275dbbe7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-275dbbe7"]])

export default __exports__